import React, { useEffect, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import classnames from 'classnames';
import { InfoTooltip } from '../../details/components/info-tooltip/info-tooltip';
import CSSclasses from '../../details/details.scss';
import classes from './select-embellishment-method.scss';
export const EmbellishmentMethodTooltipComponent = ({
  embellishmentMethodMouseOn,
  shouldDisplayEmbellishmentErrorTooltip,
  embellishmentMethod,
  isLimitedEdition,
  isSuperSpeedActive,
  classNames = ''
}) => {
  const [text, setText] = useState('');
  const updateTooltipText = () => {
    setText(prevText => {
      if (embellishmentMethodMouseOn !== null && embellishmentMethodMouseOn !== void 0 && embellishmentMethodMouseOn.tooltip) {
        return embellishmentMethodMouseOn.tooltip;
      }
      if (embellishmentMethod !== null && embellishmentMethod !== void 0 && embellishmentMethod.tooltip) {
        return embellishmentMethod.tooltip;
      }
      return prevText;
    });
  };
  useEffect(() => {
    updateTooltipText();
  }, [embellishmentMethodMouseOn, embellishmentMethod]);
  const showTooltip = !!(embellishmentMethodMouseOn !== null && embellishmentMethodMouseOn !== void 0 && embellishmentMethodMouseOn.tooltip) || !!(embellishmentMethod !== null && embellishmentMethod !== void 0 && embellishmentMethod.tooltip) || isSuperSpeedActive;
  return /*#__PURE__*/React.createElement(CSSTransition, {
    in: showTooltip,
    timeout: 300,
    mountOnEnter: true,
    unmountOnExit: true,
    onEnter: node => {
      node.style.height = '0px';
    },
    onEntering: node => {
      node.style.height = `${node.scrollHeight}px`;
    },
    onEntered: node => {
      node.style.height = 'auto';
    },
    onExit: node => {
      node.style.height = `${node.scrollHeight}px`;
    },
    onExiting: node => {
      node.style.height = '0px';
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(CSSclasses.embellishmentMethodsMessageHolder, classNames)
  }, (!embellishmentMethodMouseOn || embellishmentMethodMouseOn.tooltip.length === 0) && shouldDisplayEmbellishmentErrorTooltip && !embellishmentMethod && /*#__PURE__*/React.createElement("p", {
    className: classes.boxChooseDecorationMethodError
  }, "Choose your decorating method"), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.tooltipHolder, showTooltip && classes.tooltipHolderActive)
  }, /*#__PURE__*/React.createElement(InfoTooltip, {
    text: text,
    isSuperSpeedActive: isSuperSpeedActive,
    isLimitedEdition: isLimitedEdition
  }))));
};